import { apiRequest } from './client';
import type {
  AnswerInputPayload,
  AvailableForm,
  ResponseHistoryItem,
  ShiftCloseBinding,
  ShiftCloseFormsStatus,
  SubmissionDetail,
  SubmissionListItem,
} from '../types/formSubmissions';

// Fase 23B: cliente HTTP de ejecucion de formularios + config de checklist de Corte. businessId nunca
// viaja (sesion). El backend valida y es autoritativo.
const P = '/api';
function json(method: string, body: unknown): RequestInit { return { method, body: JSON.stringify(body) }; }
function toQuery(f: Record<string, string | number | boolean | undefined>) {
  const q = new URLSearchParams();
  Object.entries(f).forEach(([k, v]) => { if (v !== undefined && v !== '') q.set(k, String(v)); });
  // Sin `URLSearchParams.size`: no existe en Chromium 83, el WebView de Android 11 (Bloque G).
  const search = q.toString();
  return search ? `?${search}` : '';
}

// Fase 25A-R: historial de respuestas (evidencia; OWNER/MANAGER con forms.responses.view).
export interface ResponsesHistoryFilters {
  from: string;
  to: string;
  storeId?: string;
  templateId?: string;
  respondentUserId?: string;
  context?: 'MANUAL' | 'SHIFT_CLOSE' | 'ALL';
  limit?: number;
  offset?: number;
}
export const getResponsesHistory = (f: ResponsesHistoryFilters) =>
  apiRequest<{ responses: ResponseHistoryItem[]; pagination: { total: number; limit: number; offset: number; hasMore: boolean } }>(`${P}/form-submissions/responses${toQuery({ ...f })}`);

export const getAvailableForms = (storeId?: string) => apiRequest<{ forms: AvailableForm[] }>(`${P}/form-submissions/available${toQuery({ storeId })}`);
export const startSubmission = (input: { templateId: string; storeId?: string; context?: 'MANUAL' | 'SHIFT_CLOSE' }) => apiRequest<{ submission: SubmissionDetail }>(`${P}/form-submissions`, json('POST', input));
export const getSubmission = (id: string) => apiRequest<{ submission: SubmissionDetail }>(`${P}/form-submissions/${id}`);
export const saveSubmissionAnswers = (id: string, answers: AnswerInputPayload[], expectedUpdatedAt?: string) =>
  apiRequest<{ submission: SubmissionDetail }>(`${P}/form-submissions/${id}/answers`, json('PUT', { answers, expectedUpdatedAt }));
export const submitSubmission = (id: string, expectedUpdatedAt?: string) => apiRequest<{ submission: SubmissionDetail; alreadySubmitted: boolean }>(`${P}/form-submissions/${id}/submit`, json('POST', { expectedUpdatedAt }));
export const discardSubmission = (id: string) => apiRequest<{ ok: true }>(`${P}/form-submissions/${id}/discard`, json('POST', {}));
export const listSubmissions = (filters: { storeId?: string; templateId?: string; status?: string; mine?: boolean } = {}) =>
  apiRequest<{ submissions: SubmissionListItem[]; pagination: { total: number; limit: number; offset: number; hasMore: boolean } }>(`${P}/form-submissions${toQuery(filters)}`);

export const getShiftCloseFormsStatus = (storeId: string, startAt?: string) => apiRequest<ShiftCloseFormsStatus>(`${P}/form-submissions/shift-close-status${toQuery({ storeId, startAt })}`);

export const getShiftCloseConfig = () => apiRequest<{ bindings: ShiftCloseBinding[] }>(`${P}/form-shift-close-config`);
export const setShiftCloseBinding = (templateId: string, requirement: 'REQUIRED' | 'OPTIONAL', position = 0) =>
  apiRequest<{ bindings: ShiftCloseBinding[] }>(`${P}/form-shift-close-config/${templateId}`, json('PUT', { requirement, position }));
export const removeShiftCloseBinding = (templateId: string) => apiRequest<{ bindings: ShiftCloseBinding[] }>(`${P}/form-shift-close-config/${templateId}`, { method: 'DELETE' });
